window.addEventListener("load", (event) => {
  var qs = window.location.search;
  var params = new URLSearchParams(qs);

  var options = document.querySelectorAll("[data-filter-category]");

  if (params) {
    toggleViewFilters()
    params.forEach(function (value, key) {
      var filter = document.querySelector(`[data-filter-option="${key}"]`);
      var values = (value.includes(",") ? value.split(",") : [value]);

      if (filter) {
        toggleQuestion(filter.firstElementChild);
      }

      values.forEach(function (val) {
        options.forEach(function (opt) {
          var optionValue = opt.getAttribute("data-filter-category");
          if (optionValue.toLowerCase() == val.toLowerCase()) {
            toggleFilterOption(opt);
          }
        })
      })

    })
  }
});

function toggleFilterOption(e) {
  var checkBox = e.querySelector(".fake-checkbox");


  if (checkBox) {
    if (checkBox.classList.contains("checked")) {
      checkBox.classList.remove("checked");
    } else {
      checkBox.classList.add("checked");
    }
  }
}


function toggleViewFilters() {
  var parent = document.getElementsByClassName("category-content");

  if (parent.length > 0) {
    var parentTag = parent[0];

    if (parentTag.classList.contains("filters")) {
      parentTag.classList.remove("filters");
    } else {
      parentTag.classList.add("filters");
    }
  }
}


window.toggleViewFilters = toggleViewFilters;
window.toggleFilterOption = toggleFilterOption;